import type { Installment } from '@openeducation/pp-rn-shared-types';
import { atom } from 'jotai';

export const selectedInstallmentAtom = atom<Installment | null>(null);
